import React from 'react';
import { Formik, Form } from 'formik';
import { Select } from '@ohif/ui';
import { FilterFormProps } from '@custom/Utils/constants/interfaces';

const FilterForm: React.FC<FilterFormProps> = ({ filterFormInitialValue, handleSaveForm, handleResetForm, reportStatus, modalityList }) => {
  return (
    <Formik
      initialValues={filterFormInitialValue}
      onSubmit={(values, { setSubmitting }) => {
        handleSaveForm(values);  // Save form values
        setSubmitting(false);    // Prevent form from resetting
      }}
    >
      {({
        values,
        setFieldValue,
      }) => (
        <Form>
          <div className='formRow' style={{height:"85px"}}>
            <div className='formCol' style={{width:"100%"}}>
              <label htmlFor='status' className="filterPopupLabel mt-3">Status</label>
              <Select
                id='status'
                placeholder='Select'
                className='custom-bg-white'
                isMulti={true}
                isClearable={false}
                isSearchable={true}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                options={reportStatus}
                value={values.status}
                onChange={(selectedOptions) => {
                  const newStatus = selectedOptions ? selectedOptions.map(option => option) : [];
                  setFieldValue('status', newStatus);
                }}
              />
            </div>
          </div>
          <div className='formRow' style={{height:"85px"}}>
            <div className='formCol' style={{width:"100%"}}>
              <label htmlFor='modality' className="filterPopupLabel mt-3">Modality</label>
              <Select
                id='modality'
                placeholder='Select'
                className='custom-bg-white'
                isMulti={true}
                isClearable={false}
                isSearchable={true}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                options={modalityList}
                value={values.modality}
                onChange={(selectedOptions) => {
                  const newModality = selectedOptions ? selectedOptions.map(option => option) : [];
                  setFieldValue('modality', newModality);
                }}
              />
            </div>
          </div>
          <div className='filter-bottom'>
            <button type="button" className='mr-2 custom-button' onClick={() => handleResetForm(values)}>Clear</button>
            <button type="submit" className='custom-button main-theme'>Apply</button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default FilterForm;
